var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_136_2411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_136_2411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 36,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85686 7.54077H41.1426V41.8265H6.85686V7.54077Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_136_2411)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9998 7.54077C33.4712 7.54077 41.1426 15.2122 41.1426 24.6836C41.1426 32.2693 36.2355 38.6765 29.4212 40.9479C28.5641 41.0979 28.2426 40.5836 28.2426 40.1336C28.2426 39.7265 28.2641 38.3765 28.2641 36.9408C32.5712 37.7336 33.6855 35.8908 34.0284 34.9265C34.2212 34.4336 35.0569 32.9122 35.7855 32.5051C36.3855 32.1836 37.2426 31.3908 35.8069 31.3693C34.4569 31.3479 33.4926 32.6122 33.1712 33.1265C31.6284 35.7193 29.1641 34.9908 28.1784 34.5408C28.0284 33.4265 27.5784 32.6765 27.0855 32.2479C30.8998 31.8193 34.8855 30.3408 34.8855 23.7836C34.8855 21.9193 34.2212 20.3765 33.1284 19.1765C33.2998 18.7479 33.8998 16.9908 32.9569 14.6336C32.9569 14.6336 31.5212 14.1836 28.2426 16.3908C26.8712 16.0051 25.4141 15.8122 23.9569 15.8122C22.4998 15.8122 21.0426 16.0051 19.6712 16.3908C16.3926 14.1622 14.9569 14.6336 14.9569 14.6336C14.0141 16.9908 14.6141 18.7479 14.7855 19.1765C13.6926 20.3765 13.0284 21.8979 13.0284 23.7836C13.0284 30.3622 17.0355 31.8193 20.8498 32.2479C20.2284 32.7836 19.6926 33.8122 19.6926 35.4193C19.6926 37.7122 19.7141 39.5551 19.7141 40.1336C19.7141 40.5836 19.3926 41.1193 18.5355 40.9479C11.7641 38.6765 6.85693 32.2479 6.85693 24.6836C6.85693 15.2122 14.5284 7.54077 23.9998 7.54077Z",
    fill: "black",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_136_2411",
    x: 6.85693,
    y: 7.54077,
    width: 35.9999,
    height: 35.1542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.71429,
    dy: 1.71429
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_136_2411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_136_2411",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.0e24f07b080725e80c0281ae8c59a8b9.svg";
export { ForwardRef as ReactComponent };